/* global axios */
import ApiClient from './ApiClient';

class SearchAPI extends ApiClient {
  constructor() {
    super('search', { accountScoped: true });
  }

  get(params) {
    return axios.get(this.url, {
      params,
    });
  }

  contacts(params) {
    return axios.get(`${this.url}/contacts`, {
      params,
    });
  }

  conversations(params) {
    return axios.get(`${this.url}/conversations`, {
      params,
    });
  }

  messages(params) {
    return axios.get(`${this.url}/messages`, {
      params,
    });
  }
}

export default new SearchAPI();
